import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

function CallToAction(props) {
  const {
    action, autoFocus, children, ...rest
  } = props;
  const ref = useRef(undefined);

  useEffect(() => {
    if (autoFocus) {
      ref.current.focus();
    }
  }, [autoFocus, ref]);

  return (
    <Link className="primary button" ref={ref} to={action} {...rest}>
      {children}
    </Link>
  );
}

export default CallToAction;
